import React from "react";
import { Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

export default function NavLinkComp({ link, title }) {
  const { pathname } = useLocation();
  const newLocation = pathname.split("/");
  const isActive = (path) => newLocation[1] === path;
  const newLink = link
  return (
    <Nav.Link as={Link} to={link} active={isActive(newLink)}>
      {title}
    </Nav.Link>
  );
}
